import type { SurveyFormField } from '../types/surveyForm'

const SURVEY_FORM_QUESTIONS_PATH = 'survey-form/questions.json'

function assertSurveyFormFields(payload: unknown): asserts payload is SurveyFormField[] {
  if (!Array.isArray(payload)) {
    throw new Error('Survey form question config must be an array.')
  }

  payload.forEach((field, index) => {
    if (!field || typeof field !== 'object') {
      throw new Error(`Survey form question ${index + 1} must be an object.`)
    }

    const candidate = field as Partial<SurveyFormField>
    if (typeof candidate.label !== 'string' || typeof candidate.description !== 'string' || typeof candidate.link !== 'string') {
      throw new Error(`Survey form question ${index + 1} is missing required text fields.`)
    }

    if (candidate.subFields !== undefined && !Array.isArray(candidate.subFields)) {
      throw new Error(`Survey form question ${index + 1} subFields must be an array.`)
    }

    candidate.subFields?.forEach((subField, subIndex) => {
      if (!subField || typeof subField.key !== 'string' || typeof subField.label !== 'string') {
        throw new Error(`Survey form question ${index + 1} subfield ${subIndex + 1} is invalid.`)
      }
    })
  })
}

export async function fetchSurveyFormQuestions(): Promise<SurveyFormField[]> {
  const response = await fetch(`/${SURVEY_FORM_QUESTIONS_PATH}`, {
    headers: { Accept: 'application/json' },
  })

  if (!response.ok) {
    throw new Error(`Failed to load survey form questions (${response.status}).`)
  }

  const payload = await response.json()
  assertSurveyFormFields(payload)
  return payload
}
